import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Table, Button, Collapse } from "reactstrap";
import { object } from "prop-types";
import { FaLayerGroup } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
import moment from "moment";
import {
  clientProfileEntryDetailsSelector,
  changeClientProfileEntryStatusSelector,
  isStatusLoadingSelector,
  clientProfileEntryDetailsSelectorLoading,
  clientProfilePdfExportIsLoadingSelector,
} from "../../selectors";
import { watchListMatchStatusOptions } from "../../../monitoring-queue-entry/constants/monitoringQueueEntryConstants";
import Spinner from "../../../../components/common/Spinner";

import {
  getClientProfileEntryDetails,
  changeClientProfileEntryStatus,
  clearClientProfileEntryStatus,
} from "../../actions";

import "./clientProfileDetails.css";
import ConfirmationModal from "../../../../components/modals/confirmation-modal";
import { PlusExpand, SmallLogo } from "../../../../assets";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import ExportPdfButton from "./ExportPdfButton";

const COLLAPSE_KEYS = {
  AML: "AML",
  TM: "TM",
  KYC: "KYC",
};

const clientProfileEntryDetailsPage = (props) => {
  const dispatch = useDispatch();
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);
  const [confirmationModalId, setConfirmationModalId] = useState(null);
  const [confirmationModalStatus, setConfirmationModalStatus] = useState(null);
  const [collapseOpen, setCollapseOpen] = useState({
    AML: false,
    TM: false,
    KYC: false,
  });
  const toggleCollapse = (key) =>
    setCollapseOpen({ ...collapseOpen, [key]: !collapseOpen[key] });

  const changeStatusData = useSelector(changeClientProfileEntryStatusSelector);
  const isStatusDataLoading = useSelector(isStatusLoadingSelector);

  useEffect(() => {
    const { clientNumber, categoryType, clientName } = props.match.params;
    dispatch(
      getClientProfileEntryDetails({ clientNumber, categoryType, clientName })
    );
    dispatch(clearClientProfileEntryStatus());
  }, [changeStatusData]);

  const toggleModal = () => {
    setIsOpenConfirmationModal(!isOpenConfirmationModal);
  };

  const changeClientStatus = (clientId, status) => {
    toggleModal();
    setConfirmationModalId(clientId);
    setConfirmationModalStatus(status);
  };

  const handleChangeStatusSubmit = () => {
    toggleModal();
    dispatch(
      changeClientProfileEntryStatus({
        clientId: confirmationModalId,
        isActive: !confirmationModalStatus,
      })
    );
  };

  const getHighRiskTr = (type) => {
    const current = clientHighestRiskList.filter(
      (b) => b.clientHighestRiskType === type
    )[0];

    return (
      <tr>
        <td>
          {current.offerId}{" "}
          {current.customClientParams
            ? "/ " + current.customClientParams.value
            : ""}
        </td>
        <td>{current.riskLabel}</td>
        <td>{moment(current.date).format("DD.MM.YYYY")}</td>
      </tr>
    );
  };

  const offerIdLabel = (list) => {
    list.filter((c) => c.customClientParams);
    var cid =
      list.filter((c) => c.customClientParams) &&
      list.filter((c) => c.customClientParams).length > 0 &&
      list.filter((c) => c.customClientParams)[0]
        ? "OfferID / CID"
        : "OfferID";
    return cid;
  };

  const {
    clientName,
    clientNumber,
    clientHighestRiskList,
    activeOfferIds,
    inactiveOfferIds,
    linkedOfferIds,
    watchListMatches,
    negativeMediaSearchingDecisions,
    representivesHighestRiskDateFromAllActiveOffers,
    representivesHighestRiskLabelFromAllActiveOffers,
    representivesHighestRiskOfferIdFromAllActiveOffers,
    tmSingleClientReportUrl,
    hasKYCKYBIntegration,
    hasTMIntegration,
    categoryType,
  } = useSelector(clientProfileEntryDetailsSelector);
  const isLoading = useSelector(clientProfileEntryDetailsSelectorLoading);
  const isLoadingExport = useSelector(clientProfilePdfExportIsLoadingSelector);

  const noMatchesFound = (
    <tr>
      <td colSpan={10}>No matches were found</td>
    </tr>
  );

  const classNamesTD = (key) =>
    collapseOpen[key]
      ? "td-background-transition td-background-color"
      : "td-background-transition";

  const ExtraTH = ({ title, colSpan }) => (
    <thead>
      <tr className="mt-5 title">
        <td colSpan={colSpan}>{title}</td>
      </tr>
    </thead>
  );

  return (
    <Container className="mt-5 client-profile-details-entry">
      <div className="actions">
        <ExportPdfButton
          clientNumber={clientNumber}
          categoryType={categoryType}
          clientName={clientName}
        />
      </div>

      <FullscreenLoader loading={isLoading || isLoadingExport} />
      {clientNumber ? (
        <React.Fragment>
          <div className="section-box">
            {/*------------------------- AML/CFT -------------------------*/}
            <div className="d-flex align-items-center pb-2 pl-2">
              <SmallLogo height={24} width={24} />
              <p className="pl-2  m-0">AML/CFT</p>
            </div>
            <Table className="mb-0">
              <thead>
                <tr>
                  <th></th>
                  <th> Fullname</th>
                  <th>Category type</th>
                  <th>EGN / Client Number</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    width={20}
                    className={classNamesTD(COLLAPSE_KEYS.AML) + " pl-2"}
                  ></td>
                  <td width={600} className={classNamesTD(COLLAPSE_KEYS.AML)}>
                    {clientName}
                  </td>
                  <td width={200} className={classNamesTD(COLLAPSE_KEYS.AML)}>
                    {categoryType}
                  </td>
                  <td width={200} className={classNamesTD(COLLAPSE_KEYS.AML)}>
                    {clientNumber}
                  </td>
                  <td width={20} className={classNamesTD(COLLAPSE_KEYS.AML)}>
                    <span
                      className={
                        collapseOpen.AML
                          ? "button-expand-table  button-expand-table-expanded"
                          : "button-expand-table "
                      }
                      onClick={() => toggleCollapse(COLLAPSE_KEYS.AML)}
                    >
                      <PlusExpand
                        className={
                          collapseOpen.AML
                            ? "button-collapse-icon  button-collapse-tables-rotate"
                            : "button-collapse-icon"
                        }
                      />
                    </span>
                  </td>
                </tr>
              </tbody>
            </Table>
            <Collapse isOpen={collapseOpen.AML}>
              <Table className="mt-0 mb-0 custom-table-width">
                <ExtraTH
                  colSpan={3}
                  title="Client’s highest risk value from last checks for all
      currently Active OfferIds"
                />

                <thead className="thead-light-second-th">
                  <tr>
                    <th className="col-60">
                      {offerIdLabel(clientHighestRiskList)}
                    </th>
                    <th className="col-20">Highest risk</th>
                    <th className="col-20">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {activeOfferIds.length ? getHighRiskTr(0) : noMatchesFound}
                </tbody>
              </Table>

              <Table className="mt-0 mb-0 custom-table-width">
                <ExtraTH
                  colSpan={3}
                  title=" Client’s highest risk value from all checks within the past 12
                months"
                />
                <thead className="thead-light">
                  <tr>
                    <th className="col-60">
                      {offerIdLabel(clientHighestRiskList)}
                    </th>
                    <th className="col-20">Highest risk</th>
                    <th className="col-20">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {activeOfferIds.length ? getHighRiskTr(1) : noMatchesFound}
                </tbody>
              </Table>

              <Table className="mt-0 mb-0 custom-table-width">
                <ExtraTH
                  colSpan={3}
                  title="Client’s all time highest risk value and the most-recently scored
                Offer ID with that risk level"
                />
                <thead className="thead-light">
                  <tr>
                    <th className="col-60">
                      {offerIdLabel(clientHighestRiskList)}
                    </th>
                    <th className="col-20">Highest risk</th>
                    <th className="col-20">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {activeOfferIds.length ? getHighRiskTr(2) : noMatchesFound}
                </tbody>
              </Table>

              <div>
                <Table className="mt-0 mb-0 custom-table-width">
                  <ExtraTH
                    colSpan={3}
                    title=" Representative’s highest risk value from last checks for all
                currently Active OfferIds"
                  />
                  <thead className="thead-light">
                    <tr>
                      <th className="col-60">{offerIdLabel(activeOfferIds)}</th>
                      <th className="col-20">Highest risk</th>
                      <th className="col-20">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {linkedOfferIds.length &&
                    representivesHighestRiskDateFromAllActiveOffers ? (
                      <tr
                        key={representivesHighestRiskOfferIdFromAllActiveOffers}
                      >
                        <td>
                          {representivesHighestRiskOfferIdFromAllActiveOffers}
                        </td>
                        <td>
                          {representivesHighestRiskLabelFromAllActiveOffers}
                        </td>
                        <td>
                          {moment(
                            representivesHighestRiskDateFromAllActiveOffers
                          ).format("DD.MM.YYYY")}
                        </td>
                      </tr>
                    ) : (
                      noMatchesFound
                    )}
                  </tbody>
                </Table>
              </div>

              <Table className="mt-0 mb-0 custom-table-width">
                <ExtraTH colSpan={3} title="Client’s watchlist check result" />
                <thead className="thead-light">
                  <tr>
                    <th className="col-60">Watchlist check</th>
                    <th className="col-20">Type</th>
                    <th className="col-20">Decision</th>
                  </tr>
                </thead>
                <tbody>
                  {watchListMatches.length
                    ? watchListMatches.map((watchList) => {
                        const { name, type, decision } = watchList;
                        return (
                          <tr key={name}>
                            <td>{name}</td>
                            <td>{type}</td>
                            <td>
                              {decision === null
                                ? "In review"
                                : watchListMatchStatusOptions.find(
                                    (option) => option.value === decision
                                  ).label}
                            </td>
                          </tr>
                        );
                      })
                    : noMatchesFound}
                </tbody>
              </Table>
              <Table className="mt-0 mb-0 custom-table-width">
                <ExtraTH colSpan={7} title="Active offers:" />
                <thead className="thead-light">
                  <tr>
                    <th className="col-20">
                      {offerIdLabel([...inactiveOfferIds, ...activeOfferIds])}
                    </th>
                    <th>Risk value</th>
                    <th>Date</th>
                    <th>Highest risk</th>
                    <th>Highest risk date</th>
                    <th />
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {activeOfferIds.length
                    ? activeOfferIds.map((offer) => {
                        const { offerId, id, dateLatest, customClientParams } =
                          offer;
                        return (
                          <tr className="offer-tr" key={id}>
                            <td>
                              {offerId}{" "}
                              {customClientParams
                                ? "/ " + customClientParams.value
                                : ""}{" "}
                            </td>
                            <td>{offer.riskLabelLatest}</td>
                            <td>{moment(dateLatest).format("DD.MM.YYYY")}</td>
                            <td>{offer.highestRiskLabel365}</td>
                            <td>
                              {moment(offer.highestRiskDate365).format(
                                "DD.MM.YYYY"
                              )}
                            </td>
                            <td className="position-relative">
                              {isStatusDataLoading ? (
                                <Spinner text="" loading />
                              ) : (
                                <Button
                                  onClick={() => changeClientStatus(id, true)}
                                >
                                  Deactivate
                                </Button>
                              )}
                            </td>
                            <td>
                              <a
                                target="_blank"
                                href={`/singleclientreportdetails/${id}`}
                              >
                                <ReactTooltip id="details-icon" type="info">
                                  <span>Details</span>
                                </ReactTooltip>
                                <FaLayerGroup
                                  size="1.3em"
                                  data-tip
                                  data-for="details-icon"
                                  color="cornflowerblue"
                                />
                              </a>
                            </td>
                          </tr>
                        );
                      })
                    : noMatchesFound}
                </tbody>
              </Table>

              <Table className="mt-0 mb-0 custom-table-width">
                <ExtraTH colSpan={8} title="Inactive offers:" />
                <thead className="thead-light">
                  <tr>
                    <th className="col-20">
                      {offerIdLabel([...inactiveOfferIds, ...activeOfferIds])}
                    </th>
                    <th>Risk value</th>
                    <th>Date</th>
                    <th>Date of Inactivation</th>
                    <th>All-time highest risk scoring</th>
                    <th>Date of last Highest Risk scoring</th>
                    <th />
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {inactiveOfferIds.length
                    ? inactiveOfferIds.map((offer) => {
                        const {
                          offerId,
                          id,
                          riskLabelLatest,
                          customClientParams,
                          deactivationDate,
                          highestRiskLabelAllTime,
                          highestRiskDateLatest,
                        } = offer;
                        return (
                          <tr key={id}>
                            <td>
                              {offerId}
                              {customClientParams
                                ? "/ " + customClientParams.value
                                : ""}
                            </td>
                            <td>{riskLabelLatest}</td>
                            <td>
                              {moment(offer.dateLatest).format("DD.MM.YYYY")}
                            </td>
                            <td>
                              {moment(deactivationDate).format("DD.MM.YYYY")}
                            </td>
                            <td>{highestRiskLabelAllTime}</td>
                            <td>
                              {moment(highestRiskDateLatest).format(
                                "DD.MM.YYYY"
                              )}
                            </td>
                            <td>
                              {isStatusDataLoading ? (
                                <Spinner text="" loading />
                              ) : (
                                <Button
                                  onClick={() => changeClientStatus(id, false)}
                                >
                                  Activate
                                </Button>
                              )}
                            </td>
                            <td>
                              <a
                                target="_blank"
                                href={`/singleclientreportdetails/${id}`}
                              >
                                <ReactTooltip id="details-icon" type="info">
                                  <span>Details</span>
                                </ReactTooltip>
                                <FaLayerGroup
                                  size="1.3em"
                                  data-tip
                                  data-for="details-icon"
                                  color="cornflowerblue"
                                />
                              </a>
                            </td>
                          </tr>
                        );
                      })
                    : noMatchesFound}
                </tbody>
              </Table>
              <Table className="mt-0 mb-0 custom-table-width">
                <ExtraTH
                  colSpan={3}
                  title="Negative media ignoring properties:"
                />
                <thead className="thead-light">
                  <tr>
                    <th className="col-60">Source link</th>
                    <th className="col-20">Date</th>
                    <th className="col-20">Decision</th>
                  </tr>
                </thead>
                <tbody>
                  {negativeMediaSearchingDecisions.length
                    ? negativeMediaSearchingDecisions.map((offer) => {
                        const { createDate, type, id } = offer;
                        return (
                          <tr key={id}>
                            <td>
                              {offer.negativeMediaType &&
                              offer.negativeMediaType === 1
                                ? "Negative media"
                                : "Semantic Negative media"}
                            </td>
                            <td>{moment(createDate).format("DD.MM.YYYY")}</td>
                            <td>
                              {
                                watchListMatchStatusOptions.find(
                                  (option) => option.value === type
                                ).label
                              }
                            </td>
                          </tr>
                        );
                      })
                    : noMatchesFound}
                </tbody>
              </Table>

              {linkedOfferIds.length ? (
                <div>
                  <Table className="mt-0 mb-0">
                    <ExtraTH colSpan={5} title="Representatives/UBOs/" />
                    <thead className="thead-light">
                      <tr>
                        <th>Client</th>
                        <th>EGN</th>
                        <th>{offerIdLabel(linkedOfferIds)}</th>
                        <th>Highest risk</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {linkedOfferIds.length
                        ? linkedOfferIds.map((lo) => {
                            const {
                              offerId,
                              riskLabelLatest,
                              dateLatest,
                              egnUcn,
                              client,
                              customClientParams,
                            } = lo;
                            return (
                              <tr key={offerId}>
                                <td>{client}</td>
                                <td>{egnUcn}</td>
                                <td>
                                  {offerId}
                                  {customClientParams
                                    ? "/ " + customClientParams.value
                                    : ""}
                                </td>
                                <td>{riskLabelLatest}</td>
                                <td>
                                  {dateLatest
                                    ? moment(dateLatest).format("DD.MM.YYYY")
                                    : ""}
                                </td>
                              </tr>
                            );
                          })
                        : noMatchesFound}
                    </tbody>
                  </Table>
                </div>
              ) : (
                ""
              )}
            </Collapse>
          </div>
        </React.Fragment>
      ) : (
        <Spinner text="" loading />
      )}
      <ConfirmationModal
        closeModal={toggleModal}
        isOpen={isOpenConfirmationModal}
        modalHeader="Change client status"
        confirmModal={handleChangeStatusSubmit}
      >
        <p>
          Are you sure you want to&nbsp;
          <b>
            <span className={confirmationModalStatus ? "red" : "green"}>
              {confirmationModalStatus ? "Deactivate" : "Activate"}
            </span>
          </b>{" "}
          this offer ID?
        </p>
      </ConfirmationModal>

      {/*------------------------- ТМ -------------------------*/}
      <div className="linked-tables-collapse-box">
        {clientNumber && hasTMIntegration ? (
          <React.Fragment>
            <div className="section-box">
              <div className="d-flex align-items-center pb-2 pl-2">
                <SmallLogo height={24} width={24} />
                <p className="pl-2  m-0">TM</p>
              </div>
              <Table className="mb-0">
                <thead>
                  <tr>
                    <th></th>
                    <th> Fullname</th>
                    <th>Category type</th>
                    <th>EGN / Client Number</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      width={20}
                      className={classNamesTD(COLLAPSE_KEYS.TM) + " pl-2"}
                    ></td>
                    <td width={600} className={classNamesTD(COLLAPSE_KEYS.TM)}>
                      {clientName}
                    </td>
                    <td width={200} className={classNamesTD(COLLAPSE_KEYS.TM)}>
                      {categoryType}
                    </td>
                    <td width={200} className={classNamesTD(COLLAPSE_KEYS.TM)}>
                      {clientNumber}
                    </td>
                    <td width={20} className={classNamesTD(COLLAPSE_KEYS.TM)}>
                      <span
                        className={
                          collapseOpen.TM
                            ? "button-expand-table  button-expand-table-expanded"
                            : "button-expand-table "
                        }
                        onClick={() => toggleCollapse(COLLAPSE_KEYS.TM)}
                      >
                        <PlusExpand
                          className={
                            collapseOpen.TM
                              ? "button-collapse-icon  button-collapse-tables-rotate"
                              : "button-collapse-icon"
                          }
                        />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <Collapse className="pt-2" isOpen={collapseOpen.TM}>
                <Table className="mb-0">
                  <thead>
                    <tr>
                      <th>Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {tmSingleClientReportUrl ? (
                          <a href={tmSingleClientReportUrl} target="_blanc">
                            {tmSingleClientReportUrl}
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Collapse>
            </div>
          </React.Fragment>
        ) : null}
      </div>
      {/*------------------------- KYC -------------------------*/}
      <div className="linked-tables-collapse-box">
        {clientNumber && hasKYCKYBIntegration ? (
          <React.Fragment>
            <div className="section-box">
              <div className="d-flex align-items-center pb-2 pl-2">
                <SmallLogo height={24} width={24} />
                <p className="pl-2  m-0">KYC</p>
              </div>
              <Table className="mb-0">
                <thead>
                  <tr>
                    <th></th>
                    <th> Fullname</th>
                    <th>Category Type</th>
                    <th>EGN / Client Number</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      width={20}
                      className={classNamesTD(COLLAPSE_KEYS.KYC) + " pl-2"}
                    ></td>
                    <td width={600} className={classNamesTD(COLLAPSE_KEYS.KYC)}>
                      {clientName}
                    </td>
                    <td width={200} className={classNamesTD(COLLAPSE_KEYS.KYC)}>
                      {categoryType}
                    </td>
                    <td width={200} className={classNamesTD(COLLAPSE_KEYS.KYC)}>
                      {clientNumber}
                    </td>
                    <td width={20} className={classNamesTD(COLLAPSE_KEYS.KYC)}>
                      <span
                        className={
                          collapseOpen.KYC
                            ? "button-expand-table  button-expand-table-expanded"
                            : "button-expand-table "
                        }
                        onClick={() => toggleCollapse(COLLAPSE_KEYS.KYC)}
                      >
                        <PlusExpand
                          className={
                            collapseOpen.KYC
                              ? "button-collapse-icon  button-collapse-tables-rotate"
                              : "button-collapse-icon"
                          }
                        />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <Collapse className="pt-2" isOpen={collapseOpen.KYC}>
                <Table className="mb-0">
                  <thead>
                    <tr>
                      <th width={100}>ID</th>
                      <th width={200}>Offer ID</th>
                      <th>Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeOfferIds.length || inactiveOfferIds.length
                      ? [...activeOfferIds, ...inactiveOfferIds].map(
                          (offer) => {
                            return (
                              <tr>
                                <td>{offer.id}</td>
                                <td>{offer.offerId}</td>
                                <td>
                                  {offer.kyckybSubmissionUrl ? (
                                    <a
                                      href={offer.kyckybSubmissionUrl}
                                      target="_blanc"
                                    >
                                      {offer.kyckybSubmissionUrl}
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        )
                      : null}
                  </tbody>
                </Table>
              </Collapse>
            </div>
          </React.Fragment>
        ) : null}
      </div>
    </Container>
  );
};

clientProfileEntryDetailsPage.propTypes = {
  match: object.isRequired,
};

export default clientProfileEntryDetailsPage;



// WEBPACK FOOTER //
// ./src/features/client-profile/pages/client-profile-details-page/clientProfileDetails.jsx